import { useTranslation } from "react-i18next";

import { MainAlternateTab } from "src/components/MainAlternateTab";
import { TabContent } from "src/components/WorkoutItemAlternateTabContent";
import { type ExerciseData } from "src/workouts/WorkoutEditStore";

interface ExerciseMainTabProps {
  value: string;
  exercise: ExerciseData;
}

export function ExerciseMainTab(props: ExerciseMainTabProps) {
  const { t } = useTranslation();

  return (
    <MainAlternateTab value={props.value} mainLabel={t("workoutItem.main")}>
      <TabContent exercise={props.exercise} />
    </MainAlternateTab>
  );
}
